<!--
   Created by qing on 2021/2/3
   Des: 订单确认提交弹窗
-->
<template>

  <van-popup
    v-model="visible"
    :style="{ height: 'auto', minHeight: '252px', width: '100%' }"
    get-container="body"
    safe-area-inset-bottom
    round
    position="bottom">
    <div class="form-order-container">

      <div class="content">
        <template v-if="orderInfo">
          <div class="item">
            <div class="name">
              支付内容
            </div>
            <div class="des">
              {{orderInfo.payDetail}}
            </div>
          </div>
          <div class="item">
            <div class="title">
              <div class="name">
                支付金额
              </div>
              <div class="tips">
                仅支持人民币
              </div>
            </div>
            <div class="money">
              ¥{{orderInfo.payMoney}}
            </div>
          </div>
          <div class="item" style="border: none;">
            <div class="name">
              支付方式
            </div>
            <div class="payment-type-container">
              <i class="iconfont icon-weixin"></i>
              <div>微信支付</div>
            </div>
          </div>
          <div class="order-error-container" v-if="orderInfo.errorMsgList && orderInfo.errorMsgList.length">
            <div>提示：</div>
            <div
              class="order-error-item"
              v-for="s in orderInfo.errorMsgList"
              :key="s">
              {{s}}
            </div>
            <div class="order-error-item">将无法生成订单</div>
          </div>
        </template>
      </div>

      <div class="footer">
        <van-button
          @click="visible = false">
          取 消
        </van-button>
        <van-button
          type="primary"
          :disabled="Boolean(orderInfo && orderInfo.errorMsgList && orderInfo.errorMsgList.length)"
          @click="confirm">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        visible: false,
        orderInfo: null,
        command: null
      }
    },
    created() {
    },
    methods: {
      open({appId, formId, data, stepId, command}) {
        this.command = command
        this.loading = true
        this.$store.dispatch('actionCompanyPaymentApplyOrderPreCreate', {
          appId, formId, data, stepId
        }).then(res => {
          this.orderInfo = res
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
        this.visible = true
      },
      confirm() {
        this.$emit('submitOrder', {
          command: this.command,
          errList: this.orderInfo.errorMsgList
        })
        this.visible = false
      }
    }
  }
</script>

<style lang="less">

  .form-order-container {
    position: relative;
    margin-bottom: 44px;

    .content {
      margin-top: 10px;
      overflow: auto;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e6e6e6;
        padding: 16px 10px;
        width: 100%;

        .name {
          font-size: 14px;
          color: #333333;
          width: 84px;
        }

        .des {
          flex: 1;
          text-align: right;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
        }

        .title {
          display: flex;
          flex-direction: column;

          > .tips {
            font-size: 14px;
            color: #959699;
            margin-top: 10px;
          }
        }

        .money {
          font-size: 24px;
          font-weight: 500;
        }

        .payment-type-container {
          padding: 8px 10px;
          display: flex;
          align-items: center;
          border: 1px solid #05A971;
          border-radius: 5px;
          background-color: rgb(241, 250, 243);

          i {
            color: #05A971;
            font-size: 26px;
            margin-right: 10px;
          }

          > div {
            font-size: 14px;
          }
        }
      }

      .order-error-container {
        margin: 10px;

        .order-error-item {
          color: red;
          line-height: 20px;
          margin-top: 5px;
        }
      }
    }

    .footer {
      position: fixed;
      bottom: calc(env(safe-area-inset-bottom));
      left: 0;
      right: 0;
      height: 44px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .van-button {
        width: 50%;
        border-radius: 0;
      }
    }
  }
</style>